import { type POPDFHiddenCustomField } from '@webapp/platform/iam/entities/SystemPreference'
import { type POPDFHiddenCustomFieldApiModel } from '../api-models/POPDFHiddenCustomFieldApiModel'

export const mapPOPDFHiddenCustomFieldApiModel = (
  apiModel: POPDFHiddenCustomFieldApiModel
): POPDFHiddenCustomField => ({
  customField: Number(apiModel.custom_field),
  hidden: apiModel.hidden,
})

export const mapPOPDFHiddenCustomFieldToApiModel = (
  hiddenCustomField: POPDFHiddenCustomField
): POPDFHiddenCustomFieldApiModel => ({
  custom_field: String(hiddenCustomField.customField),
  hidden: hiddenCustomField.hidden,
})
